import { emitFeedback } from "../services/feedbackBus";

function safeLocalAck(actionId) {
  try {
    if (!actionId) actionId = "generic";
    localStorage.setItem(
      `trufapp.feedback.localAck:${actionId}`,
      JSON.stringify({ at: Date.now() }),
    );
    return true;
  } catch (_e) {
    return false;
  }
}

export async function runFeedbackFlow({
  actionId = "generic",
  label = "Acción",
  dbStep,
  localStep,
  successMessage = "Listo",
  errorMessage = "Error",
}) {
  emitFeedback({ stage: "pressed", actionId, label });

  const localOk = (async () => {
    try {
      if (localStep) {
        await localStep();
        return true;
      }
      return safeLocalAck(actionId);
    } catch (error) {
      console.error("[feedback-flow] local step failed", { actionId, label, name: error?.name, message: error?.message }, error);
      return false;
    }
  })();

  const localOkValue = await localOk;
  if (localOkValue) emitFeedback({ stage: "local", actionId, label });
  else {
    console.error("[feedback-flow] local failsafe rejected", { actionId, label });
    emitFeedback({ stage: "error", actionId, label, message: "LocalStorage falló" });
    throw new Error("LocalStorage falló");
  }

  try {
    await dbStep();
    emitFeedback({ stage: "db", actionId, label, message: successMessage });
  } catch (err) {
    const msg = err?.message || errorMessage;
    emitFeedback({ stage: "error", actionId, label, message: msg });
    throw err;
  }
}

